import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { NotificationViewModalComponent } from 'src/app/shared/modals/notification-view-modal/notification-view-modal.component';
import { NotificationModel } from '../../models/push/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationViewModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(notificationModel: NotificationModel,  disableModel: boolean) {
    var modalRef!: NgbModalRef;
    modalRef = this.modalService.open( NotificationViewModalComponent, { windowClass : "customModalClassCentered", size: 'xl', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
    modalRef.componentInstance.notification = notificationModel;
    modalRef.componentInstance.disableModel = disableModel;
   
    var sub: Subscription =  modalRef.closed.subscribe(()=>{
      this.modelChanged.emit(modalRef.componentInstance.confirmReject);
      sub.unsubscribe();
    })
  }
}
